import { SentimentDissatisfied as SentimentDissatisfiedIcon } from '@mui/icons-material';
import { StatusPage } from 'cleveron-web-components';
import React from 'react';
import { useLocation } from 'react-router-dom';

import Error403 from './Error403';
import Error404 from './Error404';
import Error408 from './Error408';

function ErrorPage({ error, id }) {
    const location = useLocation();
    if (error.response) {
        if (error.response.error === 403) {
            return <Error403 id={`${id}Error403`} />;
        }
        if (error.response.error === 404) {
            return <Error404 id={`${id}Error404`} />;
        }
    }
    if (error.message === 'Network Error') {
        return <Error408 id={`${id}Error408`} route={`${location.pathname}${location.search}`} />;
    }
    return (
        <StatusPage
            Icon={SentimentDissatisfiedIcon}
            buttonLink="/"
            buttonTextKey="actions.goToFrontPage"
            id={`${id}ErrorUnknown`}
            textBottomKey="error.somethingWentWrongBottom"
            textTopKey="error.somethingWentWrongTop"
            titleKey="error.somethingWentWrongTitle"
        />
    );
}

export default ErrorPage;
